export default "__VITE_ASSET__cd430a84__"